// extracted by mini-css-extract-plugin
export default {"container":"Note_container__m95eH","time_box":"Note_time_box__UAby6","note_box":"Note_note_box__DCkbm"};